module.exports = __webpack_public_path__ + "static/img/01.327082b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour1/01.jpg
// module id = il83
// module chunks = 0